import { put, takeLatest, call, ForkEffect, CallEffect, PutEffect } from 'redux-saga/effects';
import { Action } from 'typesafe-actions';
import { AddressZip, AddressZipsResponse } from 'models/AddressZipsResponse';
import * as AnalyticsActions from './action';
import { getAddressZips } from '../../../api';

export function* handleGetAddressZips(
  action: AnalyticsActions.ActionType,
  successAction: (addressZips: AddressZip[]) => AnalyticsActions.ActionType,
  failAction: (error?: string | undefined) => AnalyticsActions.ActionType,
): Generator<CallEffect<AddressZipsResponse> | PutEffect<Action<string>>, void, AddressZipsResponse> {
  const {
    payload: { successCallback, errorCallback },
  } = action;

  try {
    const { data } = yield call(getAddressZips);
    if (!data) return;
    yield put(successAction(data));
    if (successCallback) successCallback();
  } catch (error) {
    yield put(failAction(`${error}`));
    if (errorCallback) errorCallback();
  }
}

export function* watchGetAnalytics(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(AnalyticsActions.FETCH_ADDRESS_ZIPS, (action: AnalyticsActions.ActionType) =>
    handleGetAddressZips(action, AnalyticsActions.fetchAddressZipsSuccess, AnalyticsActions.fetchAddressZipsFail),
  );
}
